import PropTypes from "prop-types";
import React, { Component } from "react";
import _ from "underscore";

const VolunteerSolicitorContext = React.createContext(() => {});

const makeIdentifier = (poolId, contactIds) => {
  if (!contactIds.length) return [];
  return contactIds.map(id => String(id) + String(poolId));
};

class VolunteerSolicitorProvider extends Component {
  static propTypes = {
    fetchSolicitorsByContactAndPoolId: PropTypes.func.isRequired,
  };
  _isMounted = null;
  componentDidMount() {
    this._isMounted = true;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  safeSetState(...args) {
    if (this._isMounted) {
      this.setState(...args);
    }
  }

  uniqueIdsInFlightOrFetched = new Set();

  fetchSolicitors = (poolId, contactIds) => {
    // we are fetching solicitor objects based on poolId & contactId, so make a uid of that to track
    makeIdentifier(poolId, contactIds).forEach(id => this.uniqueIdsInFlightOrFetched.add(id));

    this.props.fetchSolicitorsByContactAndPoolId({ contactIds, poolId }).then(resp => {
      const solicitors = _.indexBy(resp, "id");
      this.safeSetState(state => ({ solicitors: { ...state.solicitors, ...solicitors } }));
    });
  };

  fetchSolicitorsIfNotCached = (poolId, contactIds) => {
    const new_ids = makeIdentifier(poolId, contactIds).filter(uid => {
      return !this.uniqueIdsInFlightOrFetched.has(uid);
    });
    if (new_ids.length) {
      this.fetchSolicitors(poolId, contactIds);
    }
  };

  state = {
    solicitors: {},
    fetchSolicitorsIfNotCached: this.fetchSolicitorsIfNotCached,
    fetchSolicitors: this.fetchSolicitors,
  };

  render() {
    return (
      // eslint-disable-next-line
      <VolunteerSolicitorContext.Provider value={this.state}>{this.props.children}</VolunteerSolicitorContext.Provider>
    );
  }
}
export { VolunteerSolicitorProvider };

export default VolunteerSolicitorContext;
